import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeactivateAccountMutationVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeactivateAccountMutationResult = { __typename?: 'Mutation' } & {
  deactivateAccount?: GraphQLTypes.Maybe<
    { __typename?: 'DeactivateAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeactivateAccountDocument = gql`
  mutation deactivateAccount($accountId: String!) {
    deactivateAccount(accountId: $accountId) {
      errors {
        message
        path
      }
    }
  }
`;
